import React from "react";

import { Frame, VideoContainer } from "./style";

type VideoPlayerProps = {
  title: string;
  src: string;
};
const VideoPlayer = (props: VideoPlayerProps) => {
  return (
    <VideoContainer>
      <Frame
        className="video-window"
        src={props.src}
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
        allowFullScreen
        title={props.title}
      />
    </VideoContainer>
  );
};

export default VideoPlayer;
